(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('BIAResponsibilityKeySystemsModalController', Controller);

    Controller.$inject = ['$scope', '$q', 'biaResponsibilityService', 'notificationService'];

    function Controller($scope, $q, biaResponsibilityService, notificationService) {

        /**
         * @property $scope.biaResponsibility -- BIA Responsibility
         * @property $scope.selectedIamSystemList -- Selected Systems
         * @property $scope.availableIamSystemList -- Available systems
         */

        $scope.ctrlCtxt = {
            availableSystemCount: 0
        };

        init();

        // System Selected
        $scope.systemSelected = function (selectedSystem, selectedSystemType) {
            $scope.biaResponsibility.IAMSystemList.push(selectedSystem);

            // Add to Selected Systems
            var selectedType = _.find($scope.selectedIamSystemList, {SystemTypeID: selectedSystemType.SystemTypeID});
            if (selectedType) {
                selectedType.IAMSystemList.unshift(selectedSystem);
            } else {
                selectedSystemType = _.clone(selectedSystemType);
                selectedSystemType.IAMSystemList = [selectedSystem];
                $scope.selectedIamSystemList.unshift(selectedSystemType);
            }

            // Remove from Available Systems
            var availableType = _.find($scope.availableIamSystemList, {SystemTypeID: selectedSystemType.SystemTypeID});
            _.remove(availableType.IAMSystemList, {IAMSystemID: selectedSystem.IAMSystemID});
            $scope.ctrlCtxt.availableSystemCount--;
        };

        // Remove System
        $scope.removeSystem = function (systemToRemove, systemTypeToRemove) {
            _.remove($scope.biaResponsibility.IAMSystemList, {IAMSystemID: systemToRemove.IAMSystemID});

            // Remove from Selected Systems
            _.remove(systemTypeToRemove.IAMSystemList, {IAMSystemID: systemToRemove.IAMSystemID});
            if (systemTypeToRemove.IAMSystemList.length === 0) {
                _.remove($scope.selectedIamSystemList, {SystemTypeID: systemTypeToRemove.SystemTypeID});
            }

            // Add To Available Systems
            var availableType = _.find($scope.availableIamSystemList, {SystemTypeID: systemTypeToRemove.SystemTypeID});
            if (!availableType) {
                systemTypeToRemove = _.clone(systemTypeToRemove);
                systemTypeToRemove.IAMSystemList = [systemToRemove];
                $scope.availableIamSystemList.unshift(systemTypeToRemove);
            } else {
                availableType.IAMSystemList.unshift(systemToRemove);
            }
            $scope.ctrlCtxt.availableSystemCount++;
        };

        // Save
        $scope.save = function () {
            biaResponsibilityService
                .updateBIAResponsibility(
                    $scope.biaResponsibility.BIAProfileID,
                    $scope.biaResponsibility.BIAResponsibilityID,
                    $scope.biaResponsibility)
                .then(function () {
                    notificationService.notify('Changes Saved Successfully');
                    $scope.close();
                });
        };

        // Format minutes to display string (e.g. 130 → "2h 10m")
        $scope.formatMinutes = function (totalMinutes) {
            if (totalMinutes == null) return '';
            var h = Math.floor(totalMinutes / 60);
            var m = totalMinutes % 60;
            if (h > 0 && m > 0) return h + 'h ' + m + 'm';
            if (h > 0) return h + 'h';
            return m + 'm';
        };

        function init() {
            $scope.biaResponsibility.IAMSystemList = $scope.biaResponsibility.IAMSystemList || [];

            _.each($scope.availableIamSystemList, function (systemType) {
                $scope.ctrlCtxt.availableSystemCount += systemType.IAMSystemList.length;
            });
        }

    }
})();